import { IconChevronRight, IconMessageCircle2 } from "@tabler/icons-react";
import { Link } from "react-router";
import PaddedView from "src/components/UI/PaddedView/PaddedView";
import { useDeviceContext } from "src/context/device-context";
import { useLocaleContext } from "src/context/locale-context";
import classes from "./TravelHelpBar.module.css";

export function TravelHelpBar() {
  const { getStringRes } = useLocaleContext();
  const { isMobile } = useDeviceContext();

  // Same Waavo feature flag as the charter widget (WaavoWidget.jsx) and the /travel-request nav
  // link (TopNavigation.jsx) — toggled per-namespace via kubectl, not a tenant name hardcoded
  // here, so turning this on for another tenant needs no code change or redeploy.
  if (window.SERVER_DATA.REACT_APP_ENABLE_CHARTER_IFRAME !== "true") {
    return null;
  }

  return (
    <div className={classes.bar}>
      <PaddedView>
        <div className={`${classes.inner} ${isMobile ? classes.mobile : ""}`}>
          <div className={classes.text}>
            <div className={classes.iconCircle}>
              <IconMessageCircle2 size={28} stroke={1.5} />
            </div>
            <div>
              <p className={classes.title}>{getStringRes("home.benefits.help.title")}</p>
              <p className={classes.subtext}>{getStringRes("home.benefits.help.subtext")}</p>
            </div>
          </div>
          <div className={classes.buttonWrap}>
            <Link to="/travel-request" className={classes.button}>
              {getStringRes("home.benefits.help.button")}
              <IconChevronRight size={18} stroke={2} />
            </Link>
            <span className={classes.badge}>{getStringRes("home.benefits.help.badge")}</span>
          </div>
        </div>
      </PaddedView>
    </div>
  );
}
